import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../../../context/MyContext';
import { FaRupeeSign } from "react-icons/fa";
import { Base_Url, CodPlanChange, remmitance, settlecod } from '../../../../config/config';
import { toast } from 'react-toastify';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Building2 } from 'lucide-react';
import Spinner from '../../../../component/spinner/spinner'
import {
    Wallet,
    CheckCircle,
    Clock,
    Zap,
    Eye,
    ArrowUpRight,
    Download,
    Calendar,
    TrendingUp,
    CreditCard,
    X,
    Truck,
    Target,
    Timer,
    Building
} from 'lucide-react';

const PageRemittances = () => {
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [settlementDestination, setSettlementDestination] = useState('wallet');
    const [activePopup, setActivePopup] = useState(null);
    const [remittanceData, setRemittanceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [settedCodData, setSetteledCodData] = useState();
    const token = localStorage.getItem('token');
    const [loadingCardId, setLoadingCardId] = useState(null);
    const cus_id = localStorage.getItem('cus_id');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [selectedPlan, setSelectedPlan] = useState(null);

    // Mock data for demonstration
    useEffect(() => {
        fetchCod();
    }, []);

    const fetchCod = async () => {
        try {
            setLoading(true);
            const response = await fetch(Base_Url + remmitance, {
                method: 'GET',
                headers: {
                    cus_id: cus_id,
                    token: token,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (data.status === "SUCCESS") {
                const apiData = data.data;
                const buttonStatus = apiData.button_status; // Get button status from API

                setSetteledCodData(apiData);
                setSelectedPlan(apiData.cod_plan);

                const formattedData = [
                    {
                        id: 'total',
                        title: 'Total Remittance',
                        amount: `₹${parseFloat(apiData.total_remittance.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                        rawAmount: parseFloat(apiData.total_remittance.remaining_amount) || 0,
                        description: `After ${apiData.total_remittance.charge_percent}% charge deduction`,
                        apiData: {
                            totalAmount: apiData.total_remittance.amount,
                            chargePercent: apiData.total_remittance.charge_percent,
                            chargeAmount: apiData.total_remittance.charge_amount,
                            remainingAmount: apiData.total_remittance.remaining_amount,
                            orders: apiData.total_remittance.orders
                        },
                        buttonEnabled: buttonStatus === 'active', // Set button state based on API
                        icon: <Wallet className="w-8 h-8" />,
                        color: 'from-purple-500 via-purple-600 to-indigo-600',
                        bgColor: 'bg-gradient-to-br from-purple-100 to-indigo-100',
                        iconColor: 'text-purple-600',
                        glowColor: 'shadow-purple-500/30',
                    },
                    {
                        id: 'last',
                        title: 'Last Remittance',
                        amount: `₹${parseFloat(apiData.last_remittance.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                        rawAmount: parseFloat(apiData.last_remittance.remaining_amount) || 0,
                        description: apiData.last_remittance_date
                            ? `Settled on ${new Date(apiData.last_remittance_date).toLocaleDateString('en-IN', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })}`
                            : 'No previous settlement',
                        apiData: {
                            totalAmount: apiData.last_remittance.amount,
                            chargePercent: apiData.last_remittance.charge_percent,
                            chargeAmount: apiData.last_remittance.charge_amount,
                            remainingAmount: apiData.last_remittance.remaining_amount,
                            orders: apiData.last_remittance.orders,
                            date: apiData.last_remittance_date
                        },
                        icon: <CheckCircle className="w-8 h-8" />,
                        color: 'from-emerald-500 via-green-500 to-teal-600',
                        bgColor: 'bg-gradient-to-br from-emerald-100 to-teal-100',
                        iconColor: 'text-emerald-600',
                        glowColor: 'shadow-emerald-500/30',
                    },
                    {
                        id: 'next',
                        title: 'Next Remittance',
                        amount: `₹${parseFloat(apiData.next_remittance.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                        rawAmount: parseFloat(apiData.next_remittance.remaining_amount) || 0,
                        description: apiData.next_remittance_date
                            ? `Scheduled for ${new Date(apiData.next_remittance_date).toLocaleDateString('en-IN', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })}`
                            : 'No upcoming settlement',
                        apiData: {
                            totalAmount: apiData.next_remittance.amount,
                            chargePercent: apiData.next_remittance.charge_percent,
                            chargeAmount: apiData.next_remittance.charge_amount,
                            remainingAmount: apiData.next_remittance.remaining_amount,
                            orders: apiData.next_remittance.orders,
                            date: apiData.next_remittance_date
                        },
                        icon: <Clock className="w-8 h-8" />,
                        color: 'from-amber-500 via-orange-500 to-red-500',
                        bgColor: 'bg-gradient-to-br from-amber-100 to-orange-100',
                        iconColor: 'text-amber-600',
                        glowColor: 'shadow-amber-500/30',
                    }
                ];

                setRemittanceData(formattedData);
            } else {
                toast.error(data.message || 'Failed to fetch remittance data');
            }
        } catch (error) {
            console.error('Error fetching COD:', error);
            toast.error('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // Payout frequency cards data
    const payoutCards = [
        {
            id: 'D+1',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 1 Day',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '2% of COD amount',
            note: '(Inclusive GST)',
            icon: <Truck className="w-8 h-8" />,
            color: 'from-blue-500 to-blue-600',
            bgColor: 'bg-gradient-to-br from-blue-50 to-blue-100',
            iconColor: 'text-blue-600'
        },
        {
            id: 'D+2',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 2 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1.75% of COD amount',
            note: '(Inclusive GST)',
            icon: <Target className="w-8 h-8" />,
            color: 'from-orange-500 to-red-500',
            bgColor: 'bg-gradient-to-br from-orange-50 to-red-100',
            iconColor: 'text-orange-600'
        },
        {
            id: 'D+3',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 3 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1% of COD amount',
            note: '(Inclusive GST)',
            icon: <Timer className="w-8 h-8" />,
            color: 'from-green-500 to-emerald-600',
            bgColor: 'bg-gradient-to-br from-green-50 to-emerald-100',
            iconColor: 'text-green-600'
        },
        {
            id: 'D+4',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 4 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '0.75% of COD amount',
            note: '(Inclusive GST)',
            icon: <Building className="w-8 h-8" />,
            color: 'from-purple-500 to-indigo-600',
            bgColor: 'bg-gradient-to-br from-purple-50 to-indigo-100',
            iconColor: 'text-purple-600'
        }
    ];

    const handleSettleNow = (cardId) => {
        setActivePopup(cardId);
    };

    const closePopup = () => {
        setActivePopup(null);
    };

    const handleActivatePayout = async (cardId) => {
        try {
            setLoadingCardId(cardId)
            setLoading(true);
            const apiUrl = Base_Url + CodPlanChange;

            // Set headers
            const headers = {
                cus_id: cus_id,
                token: token,
                'Content-Type': 'application/json',
            };

            // Set payload
            const payload = {
                retailer_id: cus_id,
                plan: cardId,
                status: "Active"
            };

            // Make POST request
            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === 'SUCCESS') {
                toast.success(response.data.message);
                setLoading(false);
            } else {
                toast.error(response.data.message);
                setLoading(false);
            }
        } catch (error) {
            console.error('API error:', error);
            setLoading(false);
        }
        finally {
            setLoadingCardId(null);
        }
    };

    const reqForSettelod = async () => {
        try {
            setLoading(true);
            const apiUrl = Base_Url + settlecod;

            const headers = {
                cus_id: cus_id,
                token: token,
                'Content-Type': 'application/json',
            };

            // Assuming settedCodData is the full API response JSON
            const totalRemittance = settedCodData?.total_remittance;

            // Fallback if orders array is not available
            const ordersArray = totalRemittance?.orders?.map(order => ({
                amount: order.amount.replace(/,/g, ''),
                order_id: order.order_id,
            })) || [];

            const payload = {
                retailer_id: cus_id,
                remaining_amount: Number(
                    (totalRemittance?.remaining_amount || '0').replace(/,/g, '')
                ).toFixed(2),
                order_ids: ordersArray,
                settle_type: settlementDestination
            };

            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === 'SUCCESS') {
                toast.success(response.data.message);
                setActivePopup(null);
            } else {
                const errorMessage = typeof response.data.message === 'object'
                    ? Object.values(response.data.message).join(', ')
                    : response.data.message || 'Something went wrong!';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error('Something went wrong!');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="z-10">
                <NavBar />
            </div>

            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}
                {/* Main Content */}
                <div className="flex-1 p-4 overflow-y-auto">
                    <div className="max-w-7xl mx-auto">
                        {/* Enhanced Header */}
                        <div className="mb-8 text-center">
                            <div className="inline-flex items-center gap-2 mb-3">
                                <div className={`p-2 rounded-lg ${isDarkMode ? 'bg-purple-500/20' : 'bg-purple-100'}`}>
                                    <FaRupeeSign className={`w-6 h-6 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                                </div>
                                <h1 className={`text-2xl font-bold bg-gradient-to-r ${isDarkMode ? 'from-white to-purple-200' : 'from-gray-900 to-purple-600'} bg-clip-text text-transparent`}>
                                    Remittance Dashboard
                                </h1>
                            </div>
                            <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'} max-w-2xl mx-auto`}>
                                Monitor your payment settlements, track remittance history, and manage upcoming payouts with real-time insights
                            </p>
                        </div>

                        {/* Enhanced Cards Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
                            {remittanceData.map((card, index) => (
                                <div
                                    key={card.id}
                                    className={`group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-[1.02] ${isDarkMode ? 'bg-white/10 backdrop-blur-lg border border-white/20' : 'bg-white/80 backdrop-blur-lg border border-white/50'}`}
                                >
                                    {/* Gradient Background with Animation */}
                                    <div className={`absolute inset-0 bg-gradient-to-br ${card.color} opacity-10 group-hover:opacity-20 transition-opacity duration-300`}></div>

                                    {/* Card Content */}
                                    <div className="relative p-3">
                                        {/* Title with Icon */}
                                        <div className="flex items-center gap-2 mb-2">
                                            <div className={`inline-flex items-center justify-center w-6 h-6 rounded-lg ${card.bgColor} group-hover:scale-110 transition-transform duration-300`}>
                                                <div className={`${card.iconColor} group-hover:scale-125 transition-transform duration-300`}>
                                                    {React.cloneElement(card.icon, { className: "w-3 h-3" })}
                                                </div>
                                            </div>
                                            <h3 className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                                {card.title}
                                            </h3>
                                        </div>

                                        {/* Main Amount */}
                                        <div className={`text-xl ml-8 font-black mb-2 bg-gradient-to-r ${card.color} bg-clip-text text-transparent group-hover:scale-105 transition-transform duration-300`}>
                                            {card.apiData.totalAmount}
                                        </div>

                                        {/* Enhanced Info Section for Total Remittance */}
                                        {card.id === 'total' && (
                                            <div className={`mb-2 p-2 rounded-lg backdrop-blur-md transition-all duration-300 ${isDarkMode
                                                ? 'bg-gradient-to-br from-white/10 to-white/5 border border-white/20'
                                                : 'bg-gradient-to-br from-white/80 to-white/60 border border-white/40'
                                                }`}>
                                                <div className="space-y-0.5">
                                                    <div className="flex items-center justify-between">
                                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                            Total COD
                                                        </span>
                                                        <span className={`text-xs font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                                                            ₹{card.apiData?.totalAmount}
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center justify-between">
                                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                            Charge ({card.apiData?.chargePercent}%)
                                                        </span>
                                                        <span className={`text-xs font-bold ${isDarkMode ? 'text-red-400' : 'text-red-600'}`}>
                                                            -₹{card.apiData?.chargeAmount}
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center justify-between pt-1 border-t border-white/20">
                                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                            Net Amount
                                                        </span>
                                                        <span className={`text-xs font-bold bg-gradient-to-r ${card.color} bg-clip-text text-transparent`}>
                                                            ₹{card.apiData?.remainingAmount}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Additional Info Section for Last & Next Remittance */}
                                        {card.id === 'last' && (
                                            <div className={`mb-2 p-1.5 rounded-lg backdrop-blur-md transition-all duration-300 ${isDarkMode
                                                ? 'bg-gradient-to-br from-green-500/10 to-green-500/5 border border-green-500/20'
                                                : 'bg-gradient-to-br from-green-50/80 to-green-50/60 border border-green-200/40'
                                                }`}>
                                                <div className="flex items-center justify-between mb-0.5">
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-green-300' : 'text-green-700'}`}>
                                                        Settlement Date
                                                    </span>
                                                    <span className={`text-xs font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                                                        26 Jun 2025
                                                    </span>
                                                </div>
                                                <div className="flex items-center justify-between">
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-green-300' : 'text-green-700'}`}>
                                                        Status
                                                    </span>
                                                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${isDarkMode ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600'}`}>
                                                        Completed
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {card.id === 'next' && (
                                            <div className={`mb-2 p-1.5 rounded-lg backdrop-blur-md transition-all duration-300 ${isDarkMode
                                                ? 'bg-gradient-to-br from-orange-500/10 to-orange-500/5 border border-orange-500/20'
                                                : 'bg-gradient-to-br from-orange-50/80 to-orange-50/60 border border-orange-200/40'
                                                }`}>
                                                <div className="flex items-center justify-between mb-0.5">
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-orange-300' : 'text-orange-700'}`}>
                                                        Scheduled Date
                                                    </span>
                                                    <span className={`text-xs font-bold ${isDarkMode ? 'text-orange-400' : 'text-orange-600'}`}>
                                                        30 Jun 2025
                                                    </span>
                                                </div>
                                                <div className="flex items-center justify-between">
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-orange-300' : 'text-orange-700'}`}>
                                                        Status
                                                    </span>
                                                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${isDarkMode ? 'bg-orange-500/20 text-orange-400' : 'bg-orange-100 text-orange-600'}`}>
                                                        Pending
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Order Count for All Cards */}
                                        <div className={`mb-2 p-1.5 rounded-lg ${isDarkMode ? 'bg-white/5' : 'bg-gray-50'}`}>
                                            <div className="flex items-center justify-between">
                                                <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    {card.id === 'last' ? 'Completed Orders' : 'Orders'}
                                                </span>
                                                <span className={`text-xs font-medium px-1.5 py-0.5 rounded-full ${card.id === 'last'
                                                    ? (isDarkMode ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600')
                                                    : card.id === 'next'
                                                        ? (isDarkMode ? 'bg-orange-500/20 text-orange-400' : 'bg-orange-100 text-orange-600')
                                                        : (isDarkMode ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-100 text-blue-600')
                                                    }`}>
                                                    {card.apiData?.orders?.length || 0} orders
                                                </span>
                                            </div>
                                            <div className="mt-1">
                                                <span className={`text-xs leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    {card.description}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="flex gap-2">
                                            {card.id === 'total' ? (
                                                <>
                                                    {/* SETTLE NOW button */}
                                                    <button
                                                        onClick={() => handleSettleNow(card.id)}
                                                        disabled={!card.buttonEnabled}
                                                        className={`flex-1 py-2 px-3 rounded-lg font-bold text-white text-xs transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-opacity-50 ${card.buttonEnabled
                                                            ? `bg-gradient-to-r ${card.color} hover:shadow-lg hover:scale-105 active:scale-95`
                                                            : 'bg-gray-400 cursor-not-allowed opacity-50'
                                                            }`}
                                                    >
                                                        <div className="flex items-center justify-center gap-1">
                                                            <Zap className="w-3 h-3" />
                                                            {card.buttonEnabled ? 'Settle Now' : 'Not Available'}
                                                        </div>
                                                    </button>

                                                    {/* Eye button */}
                                                    <button
                                                        onClick={() => {
                                                            const activeCard = remittanceData.find(c => c.id === 'total');
                                                            setSelectedOrders(activeCard?.apiData?.orders || []);
                                                            setIsModalOpen(true);
                                                        }}
                                                        className={`p-2 rounded-lg transition-all duration-300 hover:scale-110 ${isDarkMode
                                                            ? 'bg-white/10 hover:bg-white/20 text-white'
                                                            : 'bg-gray-100 hover:bg-gray-200 text-gray-600'
                                                            }`}
                                                    >
                                                        <Eye className="w-3 h-3" />
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    {/* View Details / Schedule Info */}
                                                    <button
                                                        onClick={() => {
                                                            const key = card.id === 'last' ? 'last' : 'next';
                                                            const activeCard = remittanceData.find(c => c.id === key);
                                                            setSelectedOrders(activeCard?.apiData?.orders || []);
                                                            setIsModalOpen(true);
                                                        }}
                                                        className={`flex-1 py-2 px-3 rounded-lg font-bold text-xs transition-all duration-300 transform hover:scale-105 ${isDarkMode
                                                            ? 'bg-white/10 hover:bg-white/20 text-white border border-white/20'
                                                            : 'bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-200'
                                                            }`}
                                                    >
                                                        <div className="flex items-center justify-center gap-1">
                                                            {card.id === 'last' ? (
                                                                'View Details'
                                                            ) : card.id === 'next' ? (
                                                                <>
                                                                    <Clock className="w-3 h-3" />
                                                                    Schedule Info
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </button>

                                                    {/* Download / Calendar Icon Button */}
                                                    <button
                                                        className={`p-2 rounded-lg transition-all duration-300 hover:scale-110 ${isDarkMode
                                                            ? 'bg-white/10 hover:bg-white/20 text-white'
                                                            : 'bg-gray-100 hover:bg-gray-200 text-gray-600'
                                                            }`}
                                                    >
                                                        {card.id === 'last' ? (
                                                            <Download className="w-3 h-3" />
                                                        ) : (
                                                            <Calendar className="w-3 h-3" />
                                                        )}
                                                    </button>
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* New Payout Frequency Cards Section */}
                        <div className="mb-8">
                            <div className="text-center mb-6">
                                <h2 className={`text-xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                    Payout Frequency Plans
                                </h2>
                                <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                    Choose the perfect payout schedule that fits your business needs
                                </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                {payoutCards.map((card, index) => {
                                    const isDisabled = selectedPlan && selectedPlan !== card.id;
                                    return (
                                        <div
                                            key={card.id}
                                            className={`relative overflow-hidden rounded-xl transition-all duration-300 transform 
                ${isDisabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'hover:-translate-y-1 hover:scale-[1.02]'}
                ${isDarkMode ? 'bg-white/10 backdrop-blur-lg border border-white/20' : 'bg-white backdrop-blur-lg border border-gray/20'} 
                shadow-md hover:shadow-lg`}
                                        >
                                            {/* Card Content */}
                                            <div className="pt-10 pb-4 px-4 text-center">
                                                <div className={`inline-flex items-center justify-center w-10 h-10 rounded-full ${card.bgColor} mb-3 mx-auto`}>
                                                    <div className={card.iconColor}>
                                                        {React.cloneElement(card.icon, { className: "w-5 h-5" })}
                                                    </div>
                                                </div>

                                                <h3 className={`text-sm font-bold mb-1 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                                                    {card.title}
                                                </h3>

                                                <p className={`text-xs mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    {card.subtitle}
                                                </p>

                                                <div className={`text-lg font-bold mb-1 bg-gradient-to-r ${card.color} bg-clip-text text-transparent`}>
                                                    {card.percentage}
                                                </div>

                                                <p className={`text-xs mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    {card.note}
                                                </p>

                                                <button
                                                    onClick={() => handleActivatePayout(card.id)}
                                                    disabled={isDisabled || loadingCardId === card.id}
                                                    className={`w-full py-2 px-3 rounded-lg font-bold text-white text-xs transition-all duration-300 transform 
                        ${isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-green-500 to-green-600 hover:shadow-lg hover:scale-105 active:scale-95'}
                        focus:outline-none focus:ring-2 focus:ring-green-500/30`}
                                                >
                                                    {loadingCardId === card.id ? (
                                                        <div className="flex justify-center items-center">
                                                            <Spinner />
                                                        </div>
                                                    ) : (
                                                        "Activate"
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Additional Stats Section */}
                        <div className={`p-6 rounded-2xl ${isDarkMode ? 'bg-white/10 backdrop-blur-lg border border-white/20' : 'bg-white/80 backdrop-blur-lg border border-white/50'} shadow-lg`}>
                            <div className="flex items-center justify-between mb-4">
                                <h2 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                    Quick Actions
                                </h2>
                                <button className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'} transition-colors`}>
                                    <Download className="w-3 h-3" />
                                    Export
                                </button>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-blue-500/20' : 'bg-blue-50'} hover:scale-105 transition-transform cursor-pointer`}>
                                    <Calendar className={`w-6 h-6 mb-2 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                                    <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Schedule Settlement</h3>
                                    <p className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Set up automatic payouts</p>
                                </div>

                                <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-green-500/20' : 'bg-green-50'} hover:scale-105 transition-transform cursor-pointer`}>
                                    <TrendingUp className={`w-6 h-6 mb-2 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`} />
                                    <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>View Analytics</h3>
                                    <p className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Detailed payment insights</p>
                                </div>

                                <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-purple-500/20' : 'bg-purple-50'} hover:scale-105 transition-transform cursor-pointer`}>
                                    <CreditCard className={`w-6 h-6 mb-2 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                                    <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Payment Methods</h3>
                                    <p className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Manage bank accounts</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Enhanced Popup Modal */}

            {activePopup && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className={`relative max-w-lg w-full rounded-2xl shadow-2xl ${isDarkMode ? 'bg-gradient-to-br from-slate-800 to-slate-900 text-white border border-white/20' : 'bg-gradient-to-br from-white to-gray-50 border border-gray-200'} transform transition-all duration-500 scale-100`}>

                        {/* Close Button */}
                        <button
                            onClick={closePopup}
                            className={`absolute top-4 right-4 p-2 rounded-full transition-all duration-200 hover:scale-110 ${isDarkMode ? 'hover:bg-white/10 text-gray-300 hover:text-white' : 'hover:bg-gray-100 text-gray-500 hover:text-gray-700'}`}
                        >
                            <X className="w-5 h-5" />
                        </button>

                        <div className="p-6">
                            {/* Enhanced Icon */}
                            <div className="flex justify-center mb-6">
                                <div className={`w-16 h-16 rounded-full flex items-center justify-center bg-gradient-to-br ${remittanceData.find(card => card.id === activePopup)?.color || 'from-blue-500 to-blue-600'} shadow-xl animate-pulse`}>
                                    <CreditCard className="w-8 h-8 text-white" />
                                </div>
                            </div>

                            {/* Title */}
                            <h2 className={`text-xl font-bold text-center mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                Request For Settlement
                            </h2>

                            {/* Settlement Details Table */}
                            <div className={`mb-6 p-4 rounded-xl ${isDarkMode ? 'bg-white/10' : 'bg-gray-50'}`}>
                                <div className="overflow-hidden rounded-lg">
                                    <table className="w-full">
                                        <tbody className="divide-y divide-gray-200/20">
                                            <tr>
                                                <td className={`py-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    Total COD
                                                </td>
                                                <td className={`py-2 text-right text-sm font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                                                    ₹{remittanceData.find(card => card.id === activePopup)?.apiData?.totalAmount || '0'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={`py-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    Charge Rate
                                                </td>
                                                <td className={`py-2 text-right text-sm font-bold ${isDarkMode ? 'text-amber-400' : 'text-amber-600'}`}>
                                                    {remittanceData.find(card => card.id === activePopup)?.apiData?.chargePercent || '0'}%
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={`py-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    Charge Amount
                                                </td>
                                                <td className={`py-2 text-right text-sm font-bold ${isDarkMode ? 'text-red-400' : 'text-red-600'}`}>
                                                    -₹{remittanceData.find(card => card.id === activePopup)?.apiData?.chargeAmount || '0'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={`py-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    Total Orders
                                                </td>
                                                <td className={`py-2 text-right text-sm font-bold ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                                                    {remittanceData.find(card => card.id === activePopup)?.apiData?.orders?.length || '0'} orders
                                                </td>
                                            </tr>
                                            <tr className="border-t border-white/20">
                                                <td className={`py-2 text-sm font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                    Settlement Amount
                                                </td>
                                                <td className={`py-2 text-right text-lg font-black bg-gradient-to-r ${remittanceData.find(card => card.id === activePopup)?.color || 'from-blue-500 to-blue-600'} bg-clip-text text-transparent`}>
                                                    ₹{remittanceData.find(card => card.id === activePopup)?.apiData?.remainingAmount || '0'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* View Orders Button */}
                            <div className={`mb-4 p-3 rounded-xl ${isDarkMode ? 'bg-white/5' : 'bg-gray-50'}`}>
                                <button
                                    onClick={() => {
                                        const activeCard = remittanceData.find(card => card.id === activePopup);
                                        setSelectedOrders(activeCard?.apiData?.orders || []);
                                        setIsModalOpen(true);
                                    }}
                                    className={`w-full py-2 px-4 rounded-lg font-medium text-sm transition-all duration-200 hover:scale-105 ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border border-white/20' : 'bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-200'}`}
                                >
                                    <div className="flex items-center justify-center gap-2">
                                        <Eye className="w-4 h-4" />
                                        View Orders ({remittanceData.find(card => card.id === activePopup)?.apiData?.orders?.length || '0'})
                                    </div>
                                </button>
                            </div>

                            {/* Settlement Destination Radio Buttons */}
                            <div className={`mb-6 p-4 rounded-xl ${isDarkMode ? 'bg-white/5' : 'bg-gray-50'}`}>
                                <p className={`text-sm font-medium mb-3 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Select settlement destination:
                                </p>

                                <div className="flex gap-4">
                                    {/* Wallet Option */}
                                    <label className={`flex-1 flex items-center p-3 rounded-lg cursor-pointer transition-all duration-200 ${settlementDestination === 'wallet'
                                        ? (isDarkMode ? 'bg-blue-500/20 border-blue-400' : 'bg-blue-50 border-blue-300')
                                        : (isDarkMode ? 'bg-white/5 border-gray-600 hover:bg-white/10' : 'bg-white border-gray-200 hover:bg-gray-50')
                                        } border-2`}>
                                        <input
                                            type="radio"
                                            name="settlementDestination"
                                            value="wallet"
                                            checked={settlementDestination === 'wallet'}
                                            onChange={(e) => setSettlementDestination(e.target.value)}
                                            className="sr-only"
                                        />
                                        <div className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center ${settlementDestination === 'wallet'
                                            ? 'border-blue-500 bg-blue-500'
                                            : (isDarkMode ? 'border-gray-500' : 'border-gray-300')
                                            }`}>
                                            {settlementDestination === 'wallet' && (
                                                <div className="w-2 h-2 rounded-full bg-white"></div>
                                            )}
                                        </div>
                                        <div className="flex items-center">
                                            <Wallet className={`w-4 h-4 mr-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`} />
                                            <span className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                Wallet
                                            </span>
                                        </div>
                                    </label>

                                    {/* Bank Account Option */}
                                    <label className={`flex-1 flex items-center p-3 rounded-lg cursor-pointer transition-all duration-200 ${settlementDestination === 'bank'
                                        ? (isDarkMode ? 'bg-blue-500/20 border-blue-400' : 'bg-blue-50 border-blue-300')
                                        : (isDarkMode ? 'bg-white/5 border-gray-600 hover:bg-white/10' : 'bg-white border-gray-200 hover:bg-gray-50')
                                        } border-2`}>
                                        <input
                                            type="radio"
                                            name="settlementDestination"
                                            value="bank"
                                            checked={settlementDestination === 'bank'}
                                            onChange={(e) => setSettlementDestination(e.target.value)}
                                            className="sr-only"
                                        />
                                        <div className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center ${settlementDestination === 'bank'
                                            ? 'border-blue-500 bg-blue-500'
                                            : (isDarkMode ? 'border-gray-500' : 'border-gray-300')
                                            }`}>
                                            {settlementDestination === 'bank' && (
                                                <div className="w-2 h-2 rounded-full bg-white"></div>
                                            )}
                                        </div>
                                        <div className="flex items-center">
                                            <Building2 className={`w-4 h-4 mr-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`} />
                                            <span className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                Bank Account
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex gap-3">
                                <button
                                    onClick={closePopup}
                                    className={`flex-1 py-3 px-4 rounded-xl font-bold border-2 text-sm transition-all duration-200 hover:scale-105 ${isDarkMode ? 'border-gray-600 text-gray-300 hover:bg-gray-700 hover:border-gray-500' : 'border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400'}`}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={reqForSettelod}
                                    className={`flex-1 py-3 px-4 rounded-xl font-bold text-white text-sm transition-all duration-200 transform hover:scale-105 active:scale-95 bg-gradient-to-r ${remittanceData.find(card => card.id === activePopup)?.color || 'from-blue-500 to-blue-600'} shadow-lg hover:shadow-xl`}
                                >
                                    <div className="flex items-center justify-center gap-2">
                                        <Zap className="w-4 h-4" />
                                        {loading ? <Spinner /> : "Send Request"}
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isModalOpen && (
                <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-xl w-[90%] max-w-md shadow-xl">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-bold text-gray-800 dark:text-white">Order Details</h3>
                            <button onClick={() => setIsModalOpen(false)} className="text-red-500 font-bold text-xl">&times;</button>
                        </div>
                        {selectedOrders.length > 0 ? (
                            <ul className="divide-y divide-gray-300 dark:divide-gray-700 max-h-60 overflow-y-auto">
                                {selectedOrders.map((order, idx) => (
                                    <li key={idx} className="flex justify-between py-2 text-sm text-gray-700 dark:text-gray-200">
                                        <span>Order ID: {order.order_id}</span>
                                        <span>₹{order.amount}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-sm text-gray-500">No orders available.</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PageRemittances;